module["exports"] = [
  "com",
  "net",
  "biz",
  "ch",
  "de",
  "li",
  "at",
  "ch",
  "ch"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/internet/domain_suffix.js
// module id = 2534
// module chunks = 1610